module.exports = __webpack_public_path__ + "static/media/IconCopy.f6ef4ec5.svg";